import WebglProgram from "./webglProgram";

export default class ColorWebglProgram extends WebglProgram {
  constructor(vertexShaderText, fragmentShaderText){
    super(vertexShaderText, fragmentShaderText);

    // color correction locations
    this.brightnessLocation = null;
    this.contrastLocation = null;
    this.gammaLocation = null;
  }

  prepareLocations(gl) {
    super.prepareLocations(gl);
    this.brightnessLocation = gl.getUniformLocation(this.program, "u_brightness");
    this.contrastLocation = gl.getUniformLocation(this.program, "u_contrast");
    this.gammaLocation = gl.getUniformLocation(this.program, "u_gamma");
  }

  setColorSettings(gl, colorSettings){
    gl.uniform1f(this.brightnessLocation, colorSettings.brightness);
    gl.uniform1f(this.contrastLocation, colorSettings.contrast);
    gl.uniform1f(this.gammaLocation, colorSettings.gamma);
  }
}